import { render } from "./card_ScanModal.vue?vue&type=template&id=21f2d610&bindings={\"lang\":\"data\",\"insert_dev_components\":\"data\",\"language\":\"setup\",\"close\":\"options\",\"prepareScanForUsers\":\"options\",\"skipGuests\":\"options\"}"
import script from "./card_ScanModal.vue?vue&type=script&lang=js"
export * from "./card_ScanModal.vue?vue&type=script&lang=js"

import "./card_ScanModal.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script